<template>
  <v-container>
    <v-layout row wrap justify-center>
      <v-flex xs12 md8>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>การตั้งค่าของระบบ</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form">
              <v-select
                v-model="config.home_tree_display_mode"
                :items="displayModes"
                label="การแสดงจำนวนต้นไม้ที่ลงทะเบียนในหน้าแรก"
                item-text="text"
                item-value="value"
                outline
              ></v-select>

              <v-text-field
                v-if="config.home_tree_display_mode === 'constant'"
                v-model.number="config.home_tree_constant_value"
                label="จำนวนต้นไม้ที่แสดงในหน้าแรก"
                type="number"
                min="0"
                outline
                :rules="[v => v >= 0 || 'จำนวนต้องมากกว่าหรือเท่ากับ 0']"
                @input="config.home_tree_constant_value < 0 ? config.home_tree_constant_value = 0 : null"
              ></v-text-field>

              <v-text-field
                v-if="config.home_tree_display_mode === 'offset'"
                v-model.number="config.home_tree_offset_value"
                label="จำนวนต้นไม้ที่ต้องการเพิ่มหรือลดในหน้าแรก"
                type="number"
                outline
              ></v-text-field>

              <v-divider class="my-4"></v-divider>

              <v-layout row align-center>
                <v-flex xs12 sm6>
                  <div class="subtitle-1 font-weight-medium">
                    รายละเอียดโครงการ
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="text-xs-right">
                  <v-btn color="primary" @click="openProjectDetailDialog">
                    <v-icon left>edit</v-icon>แก้ไข
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>

            <v-dialog v-model="projectDetailDialog" max-width="800px" persistent>
              <v-card>
                <v-card-title>แก้ไขรายละเอียดโครงการ</v-card-title>
                <v-card-text>
                  <div v-if="projectDetailLoading" class="text-xs-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                  <div v-else>
                    <visual-editor v-model="projectDetailHtml" />
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="closeProjectDetailDialog">
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="projectDetailSaving"
                    @click="saveProjectDetail"
                  >
                    <v-icon left>save</v-icon>บันทึก
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveConfig" :loading="saving">
              <v-icon class="mr-2">save</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VisualEditor from '@/components/VisualEditor.vue';

export default {
  components: {
    VisualEditor,
  },
  data() {
    return {
      saving: false,
      config: {
        home_tree_display_mode: 'show',
        home_tree_constant_value: 0,
        home_tree_offset_value: 0,
      },
      projectDetailHtml: '',
      projectDetailOriginalHtml: '',
      projectDetailDialog: false,
      projectDetailLoading: false,
      projectDetailSaving: false,
      descriptions: {
        home_tree_display_mode: 'รูปแบบการแสดงจำนวนต้นไม้ในหน้าแรก (show: แสดงตามจริง, constant: แสดงเป็นค่าคงที่, offset: แสดงตามจริงบวก/ลบค่าที่กำหนด, hide: ไม่แสดง)',
        home_tree_constant_value: 'จำนวนต้นไม้คงที่สำหรับแสดงในหน้าแรก',
        home_tree_offset_value: 'ผลต่างจำนวนต้นไม้ในหน้าแรก',
      },
      displayModes: [
        { text: 'แสดง', value: 'show' },
        { text: 'แสดงเป็นค่าคงที่', value: 'constant' },
        { text: 'แสดงโดยมีผลต่างตามที่กำหนด', value: 'offset' },
        { text: 'ไม่แสดง', value: 'hide' },
      ],
    };
  },
  created() {
    this.fetchConfig();
  },
  methods: {
    fetchConfig() {
      const keys = [
        'home_tree_display_mode',
        'home_tree_constant_value',
        'home_tree_offset_value',
      ];
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + '/getConfig',
          { keys }, 
          { withCredentials: true }
        ).then((response) => {
          if (Array.isArray(response.data)) {
            response.data.forEach((item) => {
              if (this.config.hasOwnProperty(item.config_key)) {
                if (item.config_key === 'home_tree_constant_value' || item.config_key === 'home_tree_offset_value') {
                  this.config[item.config_key] = parseInt(item.config_value) || 0;
                } else {
                  this.config[item.config_key] = item.config_value;
                }
                if (item.config_description) {
                  this.descriptions[item.config_key] = item.config_description;
                }
              }
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching config:', error);
        });
    },
    openProjectDetailDialog() {
      this.projectDetailDialog = true;
      this.projectDetailLoading = true;
      this.projectDetailHtml = '';
      this.projectDetailOriginalHtml = '';

      const keys = ['project_detail_html'];
      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + '/getConfig',
          { keys },
          { withCredentials: true }
        )
        .then((response) => {
          let html = '';
          if (Array.isArray(response.data)) {
            const item = response.data.find(
              (configItem) => configItem.config_key === 'project_detail_html'
            );
            if (item && typeof item.config_value === 'string') {
              html = item.config_value;
            }
          }
          this.projectDetailHtml = html || '';
          this.projectDetailOriginalHtml = this.projectDetailHtml;
        })
        .catch((error) => {
          console.error('Error fetching project detail config:', error);
          this.$swal(
            'ข้อผิดพลาด',
            'ไม่สามารถดึงรายละเอียดโครงการได้',
            'error'
          );
        })
        .finally(() => {
          this.projectDetailLoading = false;
        });
    },
    closeProjectDetailDialog() {
      const current = this.projectDetailHtml || '';
      const original = this.projectDetailOriginalHtml || '';

      if (current !== original) {
        this.$swal({
          title: 'ยืนยัน',
          text: 'คุณได้แก้ไขรายละเอียดโครงการแล้ว ต้องการออกโดยไม่บันทึกหรือไม่?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'ออกโดยไม่บันทึก',
          cancelButtonText: 'ยกเลิก',
        }).then((result) => {
          if (result && result.value) {
            this.projectDetailDialog = false;
          }
        });
      } else {
        this.projectDetailDialog = false;
      }
    },
    saveProjectDetail() {
      const html = this.projectDetailHtml || '';
      if (html === null || html === undefined) {
        this.$swal('ข้อผิดพลาด', 'ไม่พบข้อมูลรายละเอียดโครงการ', 'error');
        return;
      }

      this.projectDetailSaving = true;
      const configs = [
        {
          key: 'project_detail_html',
          value: html,
          description: 'รายละเอียดโครงการ (HTML)',
        },
      ];

      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + '/setConfig',
          { configs },
          { withCredentials: true }
        )
        .then(() => {
          this.$swal(
            'สำเร็จ',
            'บันทึกรายละเอียดโครงการเรียบร้อยแล้ว (การเปลี่ยนแปลงอาจใช้เวลาสูงสุดประมาณ 30 นาทีจึงจะแสดงผล)',
            'success'
          );
          this.projectDetailDialog = false;
        })
        .catch((error) => {
          console.error('Error saving project detail config:', error);
          this.$swal(
            'ข้อผิดพลาด',
            'ไม่สามารถบันทึกรายละเอียดโครงการได้',
            'error'
          );
        })
        .finally(() => {
          this.projectDetailSaving = false;
        });
    },
    saveConfig() {
      this.saving = true;
      const configs = Object.keys(this.config).map((key) => ({
        key: key,
        value: String(this.config[key]),
        description: this.descriptions[key] || ''
      }));

      this.axios
        .post(
          process.env.VUE_APP_IPFLASK + '/setConfig',
          { configs },
          { withCredentials: true }
        ).then(() => {
          this.$swal('สำเร็จ', 'บันทึกการตั้งค่าเรียบร้อยแล้ว', 'success');
        })
        .catch((error) => {
          console.error('Error saving config:', error);
          this.$swal('ข้อผิดพลาด', 'ไม่สามารถบันทึกการตั้งค่าได้', 'error');
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.v-toolbar__title{
  font-size: 20px !important;
  color: black !important;
}
</style>
